import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useSyncActiveWorkpapers } from '../../queries/use-sync-active-workpapers';

type SyncActiveWorkpapersConfirmProps = {
    templateIds: string[];
    isOpen: boolean;
    onClose: () => void;
    onSync: () => void;
};

function SyncActiveWorkpapersConfirm({ templateIds, isOpen, onClose, onSync }: SyncActiveWorkpapersConfirmProps): JSX.Element {
    const syncWorkpapersQuery = useSyncActiveWorkpapers();

    function handleSync(): void {
        syncWorkpapersQuery.mutate(
            { ids: templateIds },
            {
                onSuccess: () => {
                    onSync();
                    toastNotification('success', 'Open workpapers synced!');
                },
                onError: () => {
                    toastNotification('error', 'Unable to sync open workpapers!');
                },
            }
        );
    }

    return (
        <Dialog
            title="Sync Open Workpapers"
            description={`Do you want to sync the procedure template changes to all open workpapers? Workpaper procedures list will be refreshed.`}
            onClose={onClose}
            onPrimaryActionClick={handleSync}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Sync"
            secondaryAction="Cancel"
            type="info"
            isLoading={syncWorkpapersQuery.isLoading}
        />
    );
}

export default SyncActiveWorkpapersConfirm;
